'use strict';

require('./kendo.core.js');
var kendoDrawing = require('@progress/kendo-drawing');
require('./kendo.licensing.js');
require('@progress/kendo-licensing');

const __meta__ = {
    id: "color",
    name: "Color utils",
    category: "framework",
    advanced: true,
    description: "Color utilities used across components",
    depends: [ "core" ]
};

window.kendo = window.kendo || {};

kendo.deepExtend(kendo, {
    parseColor: kendoDrawing.parseColor,
    namedColors: kendoDrawing.namedColors,
    Color: kendoDrawing.Color
});

exports.__meta__ = __meta__;
